import { isEmpty } from 'lodash';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilledStar, TenderAlertIcon, UnfilledStar } from 'shared/icons/icon';
import { CardView } from 'shared/interface/enums';
import { IComponentDaum, ITenderData } from '../interface/dashboard';

interface IProps {
	data: IComponentDaum;
	cardIndex: number;
	section: string;
	className: string;
	view: string;
	rubrics: string;
	sectorId: number[];
	onSaveTender: (newsId: number, action: boolean, index: number, section: string, rubrics: string) => void;
	financersId: number[];
	isSaved: boolean;
	tenderData: ITenderData;
}

export const TenderContent: FC<IProps> = ({
	rubrics,
	data,
	section,
	className,
	cardIndex,
	view,
	sectorId,
	financersId,
	isSaved,
	tenderData,
	onSaveTender
}) => {
	const navigate = useNavigate();
	const navigationRoute = `/tenders/${isSaved ? 'saveTenders' : 'tenderList'}/${rubrics}?continentId=${data.country?.continentId || 0}${
		isEmpty(sectorId) ? `${data.country ? `&countryId=${data.country.id}` : ''}` : `&sectorId=${sectorId.toString()}`
	}&financerId=${financersId.toString()}&tenderId=${data.id}`;

	return (
		<div key={data.id} className={`${className || ''}`}>
			<div className='news-data__wrapper tender-data__wrapper d-flex justify-content-space-between align-items-center overflow-hidden'>
				<div className='d-flex gap-4px news-data cursor-pointer' onClick={() => navigate(navigationRoute)}>
					<div className='alert-icon__wrapper mr-4'>
						<TenderAlertIcon className='fill-none height--28px width--28px' />
					</div>
					<h1
						className={`font--16px line-height-22px font-weight--500 no-margin cursor-pointer ${
							(cardIndex > 1 || view === CardView.LIST_VIEW) && 'truncate--lines-2'
						} `}
					>
						{data.title}
					</h1>
				</div>
				{tenderData.type !== 'alert' && (
					<div
						className='star-icon__wrapper cursor-pointer'
						onClick={() => onSaveTender(data.id, !data.bookmarkStatus, cardIndex, section, rubrics)}
					>
						{data.bookmarkStatus ? <FilledStar className='filled-star-icon' /> : <UnfilledStar className='unfilled-star-icon' />}
					</div>
				)}
			</div>
		</div>
	);
};
